import React from 'react';
import { RichText } from '../../../../hoc/components';
import { ChoiceDescription } from '../../../../hoc/context/product/context-model';

interface ChoiceDescriptionProps {
	description: ChoiceDescription;
}
export const ChoiceDescriptionViewer: React.FC<ChoiceDescriptionProps> = ({
	description
}: ChoiceDescriptionProps) => {

	return (
		<div className="flex flex-wrap">
			{ description.header && 
				<RichText html={description.header} />
			}
			{ description.body &&
				<div className="pl-5 mt-2">
					<RichText html={description.body} />
				</div>
			}
		</div>
	);
};
